import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { toBillingType } from '@sequencehq/utils'

type GrantRefreshFrequency =
  Dashboardv99990101Api.CreditGrants.GrantRefreshFrequency
type RolloverMode = Dashboardv99990101Api.CreditGrants.RolloverMode
type CreditUnitType = Dashboardv99990101Api.CreditGrants.CreditUnitType

export const REFRESH_LABELS: Record<GrantRefreshFrequency, string> = {
  NONE: 'Does not refresh',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  HALF_YEARLY: 'Semi-annually',
  YEARLY: 'Annually'
}

// NONE -> no roll-over; ON_GRANT_REFRESH -> unused balance carries across
// refreshes within the phase only; ON_GRANT_REFRESH_AND_PHASE -> also across
// phase boundaries.
export const ROLLOVER_LABELS: Record<RolloverMode, string> = {
  NONE: 'No',
  ON_GRANT_REFRESH: 'Yes, current phase only',
  ON_GRANT_REFRESH_AND_PHASE: 'Yes, all phases'
}

export const CREDIT_TYPE_LABELS: Record<CreditUnitType, string> = {
  CURRENCY: 'Cash',
  METRIC: 'Units'
}

// Badge shown on the grant's pricing-table row — marks it as a credit grant
// (as opposed to a priced line), independent of the cash/units unit type.
export const CREDIT_TAG_LABEL = 'Credits'

// Credits are granted up front, so they always bill in advance.
export const CREDIT_BILL_LABEL = toBillingType('IN_ADVANCE')

export const EMPTY_VALUE_LABEL = '—'

export const AWAITING_FUNDING_TOOLTIP =
  'To activate this credit grant, please finalize or send the related invoice'

export const REFRESH_OPTIONS = (
  Object.entries(REFRESH_LABELS) as Array<[GrantRefreshFrequency, string]>
).map(([value, label]) => ({ label, value }))

// The amount is denominated per refresh period, which only needs saying once
// the charge cadence can differ from it.
export const GRANT_AMOUNT_LABEL = 'Amount'

export const GRANT_PERIOD_AMOUNT_LABEL = 'Credits per period'

export const GRANT_TOTAL_AMOUNT_LABEL = 'Total credits'

// Copy for the discounted-price affordance.
export const GRANT_PRICE_LABEL = 'Price'

export const GRANT_DISCOUNTED_PRICE_LABEL =
  'Charge a discounted price for these credits'

export const GRANT_DISCOUNTED_PRICE_DESCRIPTION =
  'The customer receives the full credit amount but is invoiced less.'
